import React from 'react'
import { Divider, Grid, TextField, Typography } from '@material-ui/core'
import { Page, Header, CustomButton, SecaoGenerica, ModalConfirmacao, SelecionarData } from 'components'
import useStyles from './styles'
import { SelectUsuarios } from 'components/SelectUsuarios'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import CheckIcon from '@material-ui/icons/Check'
import moment from 'moment'
import { useFormTermoNaoConformidade } from './hooks/useFormTermoNaoConformidade'

export const FormTermoNaoConformidade = (props) => {
  const { route } = props
  const classes = useStyles()

  const {
    naoConformidade,
    setNaoConformidade,
    perito,
    processandoPerito,
    setProcessandoPerito,
    testemunha,
    processandoTestemunha,
    setProcessandoTestemunha,
    exameSolicitadoSelecionado,
    setExameSolicitadoSelecionado,
    examesSolicitados,
    dataNaoConformidade,
    processandoOperacao,
    espelhoAberto,
    setEspelhoAberto,
    confirmarOperacao,
    handleClickBotaoConfirmar,
    handleChangePerito,
    handleChangeTestemunha,
    handleDataTermoNaoConformidade,
    isFormValid,
    router,
    params,
  } = useFormTermoNaoConformidade()

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} pathname={router.location.pathname} router={router} />

      <div className={classes.results}>
        <Grid container>


          <Grid item xs={12}>
            <TextField
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
              required
              name="naoconforme"
              onChange={(e) => setNaoConformidade(e.target.value)}
              label="DESCREVA A NÃO CONFORMIDADE CONSTADADA"
              value={naoConformidade}
              multiline
              minRows={5}
            />
          </Grid>

          <Grid className={classes.campoFormulario} item xs={12}>
            <SelectUsuarios
              usuariosExternos={perito}
              setUsuariosExternos={handleChangePerito}
              setProcessando={setProcessandoPerito}
              label="SELECIONE O PERITO RESPONSÁVEL"
              isFromBanco={false}
              multiplo={false}
            />
          </Grid>

          <Grid className={classes.campoFormulario} item xs={12}>
            <SelectUsuarios
              usuariosExternos={testemunha}
              setUsuariosExternos={handleChangeTestemunha}
              setProcessando={setProcessandoTestemunha}
              label="SELECIONE A TESTEMUNHA"
              isFromBanco={false}
              multiplo={false}
            />
          </Grid>

          <Grid className={classes.campoFormulario} item xs={12}>
            <AutocompleteNative
              value={exameSolicitadoSelecionado}
              name="exames"
              noOptionsText="Sem informações"
              required
              options={examesSolicitados || []}
              onChange={(event, newValue) => {
                setExameSolicitadoSelecionado(newValue)
              }}
              getOptionSelected={(option, value) => option.id === value.id}
              getOptionLabel={(option) => `EXAME ${option.exReal?.numeroExame?.toUpperCase() || ''}`}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="SELECIONE O EXAME"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            />
          </Grid>

          <Grid className={classes.campoFormulario} item xs={12}>
            <SelecionarData
              md={5}
              sm={12}
              xs={9}
              dataBD={dataNaoConformidade}
              label="SELECIONE A DATA"
              callback={handleDataTermoNaoConformidade}
              required
            />
          </Grid>


          <Grid item xs={12}>
            <Divider style={{ margin: '16px 0' }} />
            <div className={classes.botoesFormulario}>
              <CustomButton
                colorType="primary"
                variant="outlined"
                onClick={() => router.history.push(`/casos/caso/vestigio/detalhar/${params.idVestigio}`)}
                startIcon={<ArrowBackIcon />}
              >
                Cancelar
              </CustomButton>
              <CustomButton
                colorType="primary"
                disabled={!isFormValid || processandoOperacao}
                isLoading={processandoOperacao}
                onClick={handleClickBotaoConfirmar}
                startIcon={<CheckIcon />}
              >
                Cadastrar
              </CustomButton>
            </div>
          </Grid>

        </Grid>
      </div>

      <ModalConfirmacao
        aberto={espelhoAberto}
        onClose={() => setEspelhoAberto(false)}
        onConfirm={confirmarOperacao}
        processando={processandoOperacao}
        titulo="CONFIRMAÇÃO DOS DADOS PREENCHIDOS"
        confirmarLabel="Confirmar"
        cancelarLabel="Cancelar"
        confirmarColor="secondary"
        maxWidth="md"
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body2" color="textSecondary">NÃO CONFORMIDADE CONSTATADA</Typography>
            <Typography variant="body1"><b>{naoConformidade || 'NÃO INFORMADO'}</b></Typography>
          </Grid>
          <Grid item md={6} xs={12}>
            <Typography variant="body2" color="textSecondary">PERITO</Typography>
            <Typography variant="body1"><b>{perito?.nome?.toUpperCase() || 'NÃO INFORMADO'}</b></Typography>
          </Grid>
          <Grid item md={6} xs={12}>
            <Typography variant="body2" color="textSecondary">TESTEMUNHA</Typography>
            <Typography variant="body1"><b>{testemunha?.nome?.toUpperCase() || 'NÃO INFORMADO'}</b></Typography>
          </Grid>
          <Grid item md={6} xs={12}>
            <Typography variant="body2" color="textSecondary">DATA</Typography>
            <Typography variant="body1"><b>{dataNaoConformidade ? moment(dataNaoConformidade).format('DD/MM/YYYY HH:mm') : 'NÃO INFORMADO'}</b></Typography>
          </Grid>
        </Grid>
      </ModalConfirmacao>
    </Page>
  )
}

export default FormTermoNaoConformidade
